<div class="header-dialog">
    <h1 mat-dialog-title>Error on validation!</h1>
    <button mat-button class="closeBtn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div class="error-message">
        <p><mat-icon>warning</mat-icon> Please fix the following errors:</p>
        <ul>
          <li *ngFor="let error of validationErrors">{{ error }}</li>
        </ul>
      </div>
  </div>
  <div mat-dialog-actions>
      <app-button type="flat-button" class="padBtn" name="Ok" (click)="close()"></app-button>
  </div>